import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import React, { ComponentProps, PropsWithChildren } from "react";

interface Props extends PropsWithChildren<ComponentProps<typeof CheckboxPrimitive.Root>> {}

const CheckboxCard = (props: Props, ref: React.Ref<HTMLButtonElement>) => (
  <CheckboxCard.Root {...props} ref={ref}>
    {props.children}
  </CheckboxCard.Root>
);

export const baseBoxCss = css`
  border-radius: 8px;
  background-color: #fff;
  border: 2px solid var(--primary-soft-color);
  font-size: 16px;
  position: relative;
  transition: all 150ms ease;

  &[aria-invalid="true"]:not([data-state="checked"]) {
    border-color: var(--danger-color);
    color: var(--danger-color);
    background-color: var(--danger-soft-color);
  }

  &[data-state="checked"] {
    border-color: var(--primary-color);
    color: var(--primary-color);
    background-color: var(--primary-soft-color);
  }
`;

CheckboxCard.Root = styled(CheckboxPrimitive.Root)`
  ${baseBoxCss}

  padding: 6px 12px;
`;

export default React.forwardRef(CheckboxCard);
